/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-15 16:11:26
 */

import { fetchStrategyMarketList } from "@/api/modules/strategy";
import { ProFormSwitch, ProFormText, ProTable, ProFormSelect } from "@ant-design/pro-components";
import { useEffect, useState, useRef } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { message, Modal, Space, Popover, Button, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "@/utils/util";

import "./index.less";
const AutomatedRulesMarkets = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const actionRef = useRef();

	const columns = [
		{
			title: t("automatedRules.rulesMarket.table.column1"),
			key: "strategyName",
			dataIndex: "strategyName",
			width: "80%"
		},
		{
			title: t("automatedRules.rulesMarket.table.column2"),
			key: "operation",
			align: "left",
			width: 80,
			render: (_, record) => (
				<Space>
					<a
						key="modify"
						onClick={() => navigate(`/Automated/edit?id=${record.strategyId}&type=useMarket&share=${record.shareCode}`)}
					>
						{t("action.button.use")}
					</a>
					{/** 复制规则为携带规则信息，跳转到编辑也*/}
				</Space>
			)
		}
	];

	return (
		<div className="rules-containers">
			<div className="rule-market-container">
				<p className="PageTitle">{t("automatedRules.rulesMarket.title")}</p>
				<ProTable
					actionRef={actionRef}
					search={false}
					columns={columns}
					options={false}
					pagination={false}
					request={async () => {
						const res = await fetchStrategyMarketList();
						return {
							data: res.data,
							success: true
						};
					}}
				/>
			</div>
		</div>
	);
};

export default AutomatedRulesMarkets;
